module.exports = __webpack_public_path__ + "img/03.3df51641.png";